import historyUtils from 'utils/history';
import locator from 'utils/locator';

const setModalRoute = route => {
  historyUtils.push(`${locator.pathname}${locator.search}${route}`);
};

export { setModalRoute };
